const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export const hasBackendApiConfig = Boolean(API_BASE_URL);

export const fetchBackendJson = async (path) => {
  if (!API_BASE_URL) {
    throw new Error('Backend API is not configured.');
  }

  const response = await fetch(`${API_BASE_URL}${path}`);
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || payload.error || 'Backend request failed.');
  }

  return payload;
};

export const postBackendJson = async (path, body) => {
  if (!API_BASE_URL) {
    throw new Error('Backend API is not configured.');
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || payload.error || 'Backend request failed.');
  }

  return payload;
};
